import { render, staticRenderFns } from "./bffIconLabel.vue?vue&type=template&id=30d537e1&scoped=true&"
import script from "./bffIconLabel.vue?vue&type=script&lang=ts&"
export * from "./bffIconLabel.vue?vue&type=script&lang=ts&"
import style0 from "./bffIconLabel.vue?vue&type=style&index=0&id=30d537e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d537e1",
  null
  
)

export default component.exports